var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.294,
    height: 10.294,
    viewBox: "0 0 10.294 10.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Free-Icons",
    transform: "translate(0.4 0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M7.747,3,9.329,6.165h3.165L9.857,8.8l1.055,3.692L7.747,10.648,4.582,12.494,5.637,8.8,3,6.165H6.165Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#003e8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.6277bfac1003e22ba3d623ed67ad0443.svg";
export { ForwardRef as ReactComponent };